import { GatewayPlatforms } from '@lentau/core/api/gateway';
import { RegistrationRequest } from 'angular-api-gateway/v1/model/registrationRequest';

export const TABLET_SETTINGS: string = 'loyalty-tablet-settings';

export interface TabletSettings {
  tkId: string;
  type: number;
  name: string;
  secondName: string;
  thirdName: string;
}

export const mapTabletType: Map<number, GatewayPlatforms> = new Map([
  [0, GatewayPlatforms.TABLET],
  [1, GatewayPlatforms.KIOSK],
  [2, GatewayPlatforms.CALL_CENTER],
  [3, GatewayPlatforms.TSIPK],
]);

export const mapTabletRegType: Map<number, RegistrationRequest.RegistrationSourceEnum> = new Map([
  [0, RegistrationRequest.RegistrationSourceEnum.Tablet],
  [1, RegistrationRequest.RegistrationSourceEnum.Kiosk],
  [2, RegistrationRequest.RegistrationSourceEnum.CallCenter],
  [3, RegistrationRequest.RegistrationSourceEnum.Tsipk],
]);

export interface TabletsOrigin {
  shop: string;
  createdBy: string;
}

export interface ReferralData {
  campaignId: string;
  externalId: string;
}
